import React from 'react';
import {
  Modal, Table, Typography, Space, Button, theme, Form, Select, Popconfirm, message
} from 'antd';
import { ApartmentOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import {
    getEmployeesBySupervisor, 
    getEmployeesWithoutSupervisor, 
    assignEmployeeToSupervisor, 
    unassignEmployeeFromSupervisor
} from '../../../../apis/SupervisoresApi';

const { Text } = Typography;

export default function OrganigramaModal({ open, onClose, supervisor }) {
  const { token } = theme.useToken();
  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [loadingOpts, setLoadingOpts] = React.useState(false);
  const [form] = Form.useForm();

  //const supervisorId = supervisor?.odoo_id ?? supervisor?.id;
  const supervisorId = supervisor?.id;


  // Cargar tabla (backend real)
  const refreshData = React.useCallback(async () => {
    setLoading(true);
    const response = await getEmployeesBySupervisor(supervisorId);
    if (response.ok) {
      setRows(response.payload || []);
    }
    setLoading(false);
  }, [supervisorId]);

  // Cargar opciones del dropdown (mock)
  const loadOptions = React.useCallback(async () => {
    setLoadingOpts(true);
    const list = await getEmployeesWithoutSupervisor();
    setOptions(list.payload || []);
    setLoadingOpts(false);
  }, []);

  React.useEffect(() => {
    if (open) {
      refreshData();
      loadOptions();
    }
  }, [open, refreshData, loadOptions]);

  const handleAdd = async (values) => {
    const empleadoId = values.empleado_id;
    if (!empleadoId) return;

    // evitar duplicados en tabla
    if (rows.some(r => Number(r.empleado) === Number(empleadoId))) {
      message.warning('Ese empleado ya está asignado al supervisor.');
      return;
    }

    const res = await assignEmployeeToSupervisor(supervisorId, empleadoId);
    if (res.ok) {
      const opt = options.find(o => Number(o.value) === Number(empleadoId));
      // agrega fila mockeada
      setRows(prev => [
        ...prev,
        {
          empleado: Number(opt?.value),
          name: opt?.label,
          nomina_employee_number: opt?.nomina_employee_number ?? '',
          resource_calendar_name: opt?.resource_calendar_name ?? '',
        },
      ]);
      refreshData();
      loadOptions();
      message.success('Empleado agregado');
      form.resetFields(['empleado_id']);
    } else {
      message.error('No se pudo agregar el empleado');
    }
  };

  const handleRemove = async (empleadoId) => {
    const res = await unassignEmployeeFromSupervisor(empleadoId);
    if (res.ok) {
      setRows(prev => prev.filter(r => Number(r.empleado) !== Number(empleadoId)));
      loadOptions();
      message.success('Empleado eliminado');
    } else {
      message.error('No se pudo eliminar el empleado');
    }
  };

  const columns = [
    { title: 'Empleado', dataIndex: 'nomina_employee_number', key: 'nomina_employee_number', width: 120 },
    { title: 'Nombre', dataIndex: 'name', key: 'name' },
    { title: 'Horario', dataIndex: 'resource_calendar_name', key: 'resource_calendar_name', width: 180 },
    {
      title: 'Acciones',
      key: 'actions',
      width: 90,
      align: 'center',
      render: (_, record) => (
        <Popconfirm
          title="Eliminar"
          description="¿Quitar este empleado del supervisor?"
          okText="Sí"
          cancelText="No"
          onConfirm={() => handleRemove(record.empleado)} // se envía el id del empleado de la fila
        >
          <Button type="text" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  return (
    <Modal
      className="org-modal"
      open={open}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <ApartmentOutlined />
          <span>Organigrama</span>
        </div>
      }
      onCancel={onClose}
      destroyOnClose
      okButtonProps={{ style: { display: 'none' } }}
      width={760}
    >
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Text strong style={{ fontSize: 16 }}>Empleados asignados a: {supervisor?.nombre ?? '—'}</Text>

        {/* Formulario: dropdown + botón Agregar */}
        <Form form={form} layout="inline" onFinish={handleAdd} style={{ gap: 8 }}>
          <Form.Item
            name="empleado_id"
            rules={[{ required: true, message: 'Selecciona un empleado' }]}
            style={{ flex: 1, minWidth: 260 }}
          >
            <Select
              placeholder="Selecciona empleado"
              options={options.map((opt) => ({
                value: opt.empleado,
                label: opt.name,
              }))}
              loading={loadingOpts}
              allowClear
              showSearch
              optionFilterProp="label"
              style={{ width: 360 }}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
              Agregar
            </Button>
          </Form.Item>
        </Form>

        <Table
          className="org-table"
          dataSource={rows}
          columns={columns}
          rowKey="empleado"   // id del empleado en la fila
          size="middle"
          bordered
          loading={loading}
          pagination={false}
          scroll={{ y: 300 }}
          sticky
        />
      </Space>
    </Modal>
  );
}